import { mergeDeep } from './common';

export function mergeLocales(data) {
    let locales = {};

    Object.keys(data).forEach(groupKey => {
        let groupData = data[groupKey];

        if(!Array.isArray(groupData)) {
            groupData = [ groupData ];
        }

        for(let d of groupData) {
            Object.keys(d).forEach(lang => {
                if(!(lang in locales)) {
                    locales[lang] = {};
                }
                if(!(groupKey in locales[lang])) {
                    locales[lang][groupKey] = {};
                }
                
                locales[lang][groupKey] = mergeDeep(locales[lang][groupKey], d[lang]);
            });
        }
    });

    return locales;
}